import { render, staticRenderFns } from "./FieldsetCustomerContact.vue?vue&type=template&id=b78e2958&scoped=true&"
import script from "./FieldsetCustomerContact.vue?vue&type=script&lang=js&"
export * from "./FieldsetCustomerContact.vue?vue&type=script&lang=js&"
import style0 from "./FieldsetCustomerContact.vue?vue&type=style&index=0&id=b78e2958&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b78e2958",
  null
  
)

export default component.exports